/** 
 * @file API For Interacting with Mad Network
 * 
 * @version 0.1
 * @author MadNet
 * @copyright 2022
 * 
 */

const MadWalletJS = require("./src/Wallet.js");
module.exports = MadWalletJS;